import { render } from "./ForumDashboard.vue?vue&type=template&id=7624e424&scoped=true"
import script from "./ForumDashboard.vue?vue&type=script&lang=js"
export * from "./ForumDashboard.vue?vue&type=script&lang=js"

import "./ForumDashboard.vue?vue&type=style&index=0&id=7624e424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7624e424"]])

export default __exports__